import request from '@/utils/request'
// 获取权限内完整省市区地区列表下拉
export function getClientAreaTree () {
  return request({
    url: '/v1/adb/sca_visit_client/areatree',
    method: 'get'
  })
}
